// routes/luxotticaRoutes.js

import { IconicLayout } from '../pages/iconic';
import Dashboard from '../pages/luxottica-dashboard';
import UserList from '../pages/manuela-users';
import UploadOriginal from '../pages/luxottica-images-upload-original';
import UploadResized from '../pages/luxottica-images-upload-resized';
import UploadLensRemoved from '../pages/luxottica-images-upload-lens-removed';
import ImageReviewOriginal from '../pages/luxottica-images-view-original';
import ImageReviewResized from '../pages/luxottica-images-view-resized';
import ImageReviewLensRemoved from '../pages/luxottica-images-view-lens-removed';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import ReviewPage from '@/pages/luxottica-review';
import AdminReviewManager from '@/pages/luxottica-review-admin';
import MaskAnnotatorDemo from '@/pages/luxottica-review-LensesMask';
import CSVColumnMapper from '@/pages/luxottica-data-ingest';
import { Navigate } from 'react-router-dom';
import ReviewManagerFinal from '@/pages/luxottica-review-FinalHumanReview';
import { buildPath, buildRedirectPaths } from '../utils/routeBuilder';
import LuxotticaSystemStatus from '@/pages/luxottica-system-status';
import WorkflowManager from '@/pages/luxottica-workflows';
import GlassesFramesTable from '@/pages/luxottica-GlassesFrames-list';
import { Glasses } from 'lucide-react';
import DynamicNodeSystem from '@/pages/luxottica-sample-node-manager';
import TemplateEditor from '@/pages/luxottica-sample-node-manager-view';
import SegmentationVerificationTable from '@/pages/luxottica-segmentation-verification';
import WorkflowAnalyticsDashboard from '@/pages/luxottica-workflow-analytics';
import UserWorkActivityDashboard from '@/pages/luxottica-user-analytics';
import LensRecVerificationTable from '@/pages/luxottica-lensrec-verification';
import WorkRecordsTable from '@/pages/luxottica-work-records';
import RevisionNodesPage from '@/pages/luxottica-revision';
import RevisionGlassesFramePage from '@/pages/luxottica-revision-glasses-frames';
import WorkBatchesList from '@/pages/luxottica-work-batches';
import ArtworkListComponent from '@/pages/iconic-artworkstatus';
import ArtworkExportDashboard from '@/pages/iconic-artworkstatus';

// Redirect configuration constants
const ICONIC_REDIRECT_PATHS = buildRedirectPaths('/iconic');

const iconicRoutes = [
  // Root redirect to dashboard
  { 
    path: buildPath('/iconic'), 
    element: <Navigate to={buildPath('/iconic/dashboard')} replace />
  },
  // Dashboard
  { 
    path: buildPath('/iconic/dashboard'), 
    element: (
      <ProtectedRoute 
        projectId="iconic" 
        requireProjectAccess={false}
        requiredRoles={['admin', 'manager', 'reviewer']}
        loginPath={ICONIC_REDIRECT_PATHS.LOGIN}
        unauthorizedPath={ICONIC_REDIRECT_PATHS.UNAUTHORIZED}
        projectAccessDeniedPath={ICONIC_REDIRECT_PATHS.PROJECT_ACCESS_DENIED}
      >
        <IconicLayout>
          <Dashboard />
        </IconicLayout>
      </ProtectedRoute>
    )
  },
  // Overview
  { 
    path: buildPath('/iconic/artworks'), 
    element: (
      <ProtectedRoute 
        projectId="luxottica" 
        requireProjectAccess={true}
        requiredRole="admin"
        loginPath={ICONIC_REDIRECT_PATHS.LOGIN}
        unauthorizedPath={ICONIC_REDIRECT_PATHS.UNAUTHORIZED}
        projectAccessDeniedPath={ICONIC_REDIRECT_PATHS.PROJECT_ACCESS_DENIED}
      >
        <IconicLayout>
          <ArtworkExportDashboard />
        </IconicLayout>
      </ProtectedRoute>
    )
  }
];

export default iconicRoutes;